export const INTRO_HOME = `
<div class="reward-content">
  <div class="reward-part">
    <p style="text-align:left">
    Là đơn vị độc quyền cung cấp nền tảng bình chọn chính thức của cuộc thi Nét đẹp Sinh viên, Bvote tự hào đồng hành cùng các thí sinh, góp phần mang đến kết quả công bằng, minh bạch.
    </p>
    </div>
  </div>
</div>
`;

export const INTRO_TITLE = `Là cổng bình chọn chính thức của cuộc thi Nét đẹp Sinh viên, Bvote tự hào mang đến giải pháp bình chọn trực tuyến công bằng, minh bạch cho các thí sinh.`;

export const INTRO = `
  <div class="reward-content">
  <div class="reward-part">
<div class="item">
<p>
<span style="font-size:16px; font-family: roboto; ">
<span style="color:#000000">
<span style="font-family:roboto">
Cổng bình chọn Bvote sẽ đồng hành cùng cuộc thi để tìm kiếm ra những thí sinh được yêu thích nhất qua sự bình chọn của khán giả. 
  </span>
  </span>
  </span>
  </p>
   <p>
  <span style="font-size:16px"><span style="color:#000000">
  <span style="font-family:roboto">
  Việc hoạt động dựa trên công nghệ chuỗi khối của Blockchain giúp giải pháp bình chọn của Bvote sở hữu những ưu điểm vượt trội về tính an toàn, bảo mật, đem lại kết quả công khai và minh bạch nhất. Thay vì sử dụng phương thức truyền thống bằng tin nhắn, khán giả sẽ ủng hộ cho thí sinh mình yêu thích nhất thông qua hệ thống bình chọn trên Website. Giải pháp này cho phép mọi người theo dõi kết quả liên tục, trực tiếp trên hệ thống, một điều mà các hình thức cũ không làm được. Không chỉ loại bỏ nguy cơ gian lận, Bvote còn mang đến trải nghiệm bình chọn mới lạ, tiện lợi và dễ sử dụng. Nhất là khi giải pháp bình chọn của Bvote còn kết hợp cùng các ví điện tử uy tín để đảm bảo mức độ bảo mật cao và giảm thiểu tối đa tình trạng hack vote.
  <br/>
  <br/>
  </span>
    </span>
      </p> 
      <p>
      &nbsp;
      </p> 
      <p>
      <span style="font-size:16px">
      <span style="color:#000000">
      <span style="font-family:roboto">
      <strong>
      Cách thức bình chọn:
      </strong>
      <br/>
      <br/>
      <strong>
      Ban tổ chức đưa lên thông tin thí sinh để khán giả bình chọn
      </strong>
      </span>
      </span>
      <span style="color:#000000">
      <span style="font-family:roboto"> 
      </span>
      </span>
      </span>
      </p>
       <p>
       <span style="font-size:16px">
       <span style="color:#000000">
       <span style="font-family:roboto">
       - <i>Bước 1: &nbsp;</i> Truy cập website: https://netdepsinhvien1.bvote.vn/. Tại phần Danh sách thí sinh, click chi tiết vào thí sinh muốn bình chọn
       </span>
       </span>
       </span>
       </p> 
       <p>
       <span style="font-size:16px">
       <span style="color:#000000">
       <span style="font-family:roboto">
       - <i>Bước 2: &nbsp;</i> Click Bình chọn qua VNPAY hoặc Bình chọn qua thẻ. Hệ thống sẽ trả về 1 link thanh toán để bình chọn thí sinh.
       </span>
       </span>
       </span>
       </p>
        <p><span style="font-size:16px">
        <span style="color:#000000">
        <span style="font-family:roboto">
        - <i>Bước 3: &nbsp;</i> Truy cập link thanh toán, tiến hành thanh toán (tương đương bình chọn). 

        </span>
        </span>
        </span>
        </p>
         <p>
         <span style="font-size:16px">
         <span style="color:#000000">
         <span style="font-family:roboto">
         - <i>Bước 4: &nbsp;</i> Hệ thống check thanh toán thành công, hệ thống Bvote sẽ tiến hành lưu trữ kết quả bình chọn. Phí bình chọn theo gói lựa chọn và 1 lượt bình chọn qua Momo tương đương với số điểm theo gói bình chọn mà khán giả đã chọn. Lưu ý sẽ không giới hạn số lượt bình chọn và số thí sinh bình chọn.
 
         </span>
         </span>
         </span>
         </p> 
   
         <br/>
          <p>
          &nbsp;
          </p> 
          <p>
          <span style="font-size:16px">
          <strong>
          <span style="color:#000000">
          <span style="font-family:roboto">
          Cơ cấu giải thưởng: 
          </span>
          </span>
          </strong>
          </span>
          </p> 
          <br/>
          <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto;font-weight: bold">
           VOTING VÒNG THI ẢNH ONLINE
          </p> 
           <br/>
           <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto">
            BTC sẽ cập nhật ảnh của tất cả các thí sinh lên nền tảng BVote và sẽ tiến hành vote trực tiếp. Top 6 thí sinh (3 Nam, 3 Nữ) chiến thắng sẽ nhận được những đặc quyền như sau:
          </p> 

           <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto">
           + Được tiến thẳng vào vòng Truyền hình thực tế - một format hoàn toàn mới của cuộc thi năm nay mà không cần phải tham gia vòng Sơ khảo
          </p>  
          
           <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto">
          + Được tự chọn Đội cho chính mình tại vòng Truyền hình thực tế
          </p>  
          
             <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto">
           + Nhận được một khóa đào tạo tất cả các kỹ năng của Viện Hoa hậu Người mẫu Việt Nam trước khi bước vào vòng thi Truyền hình thực tế vô cùng khốc liệt
          </p>  
          
          <br/>
          <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto;font-weight: bold">
           VOTING TẠI VÒNG THI TRUYỀN HÌNH THỰC TẾ
          </p> 
           <br/>
           <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto">
          Các thí sinh không may bị loại tại vòng Truyền hình thực tế cũng đừng lo lắng. BTC sẽ cập nhật ảnh của Top các thí sinh lọt vào vòng Truyền hình thực tế lên nền tảng BVote và sẽ tiến hành vote trực tiếp. Top các thí sinh chiến thắng tại sẽ nhận được những giải thưởng vô cùng giá trị như sau:
          </p> 

           <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto">
           + Top 2 thí sinh (1 Nam và 1 Nữ) có tỷ lệ bình chọn cao nhất sẽ được tiến thẳng vào Top 12 chung cuộc (6 Nam, 6 Nữ) tham gia phần thi ứng xử trong Đêm Chung kết.
          </p>  
          
           <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto">
          + Nhận được thư mời của Chủ tịch The Miss Global và được vinh danh tại Malaysia trong chuyến đi 3 Ngày 2 Đêm gặp Chủ tịch The Miss Global
          </p>  
          
             <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto">
           + Được nền tảng Booking KOL bảo trợ hình ảnh
          </p>  
          
             <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto">
           + Được cùng với Đại sứ của cuộc thi tham gia Media Tour đến các trường Đại học.
          </p>  
          
             <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto">
           + Học bổng toàn phần tại Viện Hoa hậu Người mẫu Việt Nam trị giá lên đến 100.000.000 VNĐ
          </p>  
          
             <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto">
           + Học bổng khóa học Tiếng anh trị giá lên đến 90.000.000 VNĐ
          </p>  
          
             <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto">
           + Nhận được gói tập 6 tháng tại Trung tâm Huấn luyện Thể hình Get Fit Gym&Yoga
          </p>  
          
             <p>
          <span style="font-size:16px">
          <span style="color:#000000">
          <span style="font-family:roboto">
           + Ngoài ra, Top 10 bình chọn cao nhất sẽ nhận được 1 chuyến du lịch tại Măng Đen 3 Ngày 2 Đêm
          </p>  
</div>
</div>
</div>
  `;
